import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

// Hardcoded English defaults — instant fallback
export const EN_DEFAULTS = {
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.add': 'Add',
  'common.loading': 'Loading...',
  'common.name': 'Name',
  'common.color': 'Color',
  'common.key': 'Key',
  'common.value': 'Value',
  'common.reset': 'Reset',
  'common.confirm': 'Confirm',
  'common.restore': 'Restore',
  'common.maximize': 'Maximize',
  'common.move_up': 'Move up',
  'common.move_down': 'Move down',
  'common.open_link': 'Open Link ↗',
  'header.brand_sub': 'Image Annotation System',
  'header.add_image': '+ Add Image',
  'header.import': '⤓ Import',
  'header.menu_title': 'Menu',
  'header.manage_tags': 'Tags',
  'header.manage_users': 'Users',
  'header.manage_languages': 'Languages',
  'header.my_account': 'My Account',
  'header.logout': 'Logout',
  'header.search_placeholder': 'Search images...',
  'header.toggle_theme': 'Toggle theme',
  'header.documentation': 'Documentation',
  'header.embed_gallery': 'Embed gallery',
  'gallery.loading': 'Loading...',
  'gallery.empty': 'No images found.',
  'gallery.empty_start': 'No images registered.',
  'gallery.empty_hint': 'Try other filters.',
  'gallery.empty_start_hint': "Click '+ Add Image' to start.",
  'gallery.filter_clear': '✕ Clear',
  'gallery.filter_label': 'Filter:',
  'gallery.images_count': 'images',
  'gallery.select_image': 'Select image',
  'gallery.selected_count': '{n} selected',
  'gallery.select_all': 'Select all',
  'gallery.download_targz': 'Download .tar.gz',
  'gallery.delete_selected': 'Delete',
  'gallery.clear_selection': 'Clear',
  'gallery.confirm_delete_selected': 'Delete {n} selected image(s) and all their annotations?',
  'image.annotate': '✎ Annotate',
  'image.view': '👁 View',
  'image.edit_annotations': '✎ Edit annotations',
  'image.close_btn': '✕ Close',
  'image.edit': 'Edit image',
  'image.export_json': 'Export annotations as JSON',
  'image.export_svg': 'Export as embeddable SVG',
  'image.copy_svg_url': 'Copy embeddable SVG URL',
  'image.svg_url_copied': 'SVG URL copied to clipboard',
  'image.copy_thumb_url': 'Copy thumbnail URL',
  'image.thumb_url_copied': 'Thumbnail URL copied to clipboard',
  'image.copy_failed': 'Could not copy to clipboard',
  'image.embed_example': 'Open embed example page',
  'image.delete': 'Delete image',
  'image.annotations_count': 'annotations',
  'image.legend': 'Legend',
  'image.legend_hint': 'Hover an item to highlight its shape on the image',
  'image.confirm_delete': 'Delete this image and all annotations?',
  'image.deleted': 'Image deleted.',
  'image.updated': 'Image updated!',
  'image.added': 'Image added successfully!',
  'upload.title': 'Add Image',
  'upload.tab_file': 'File',
  'upload.tab_url': 'Link (URL)',
  'upload.drop_text': 'Drag or click to select',
  'upload.drop_hint': 'PNG, JPG, WEBP, GIF',
  'upload.url_placeholder': 'https://example.com/image.jpg',
  'upload.name_label': 'Image Name',
  'upload.name_placeholder': 'Ex: Circuit Diagram',
  'upload.tags_label': 'Tags',
  'upload.submit': 'Add',
  'upload.submitting': 'Adding...',
  'import.title': 'Import images',
  'import.help': 'Upload a .zip or .tar.gz archive of images, annotations and tags.',
  'import.drop_text': 'Drag or click to select an archive',
  'import.drop_hint': '.zip or .tar.gz',
  'import.submit': 'Import',
  'import.submitting': 'Importing…',
  'import.done': 'Import complete',
  'import.images': 'images',
  'import.annotations': 'annotations',
  'import.tags': 'new tags',
  'import.warnings': 'warning(s)',
  'image_meta.title': 'Edit Image',
  'image.open_link': 'Open image link',
  'image_meta.name_label': 'Name',
  'image_meta.link_label': 'Link',
  'image_meta.link_placeholder': 'https://...',
  'image_meta.description_label': 'Description',
  'image_meta.description_placeholder': 'Describe this image (optional)',
  'image_meta.properties_label': 'Custom properties',
  'prop.add': '+ Add property',
  'prop.add_item': '+ Add item',
  'prop.key': 'key',
  'prop.remove': 'Remove',
  'prop.value_type': 'Value type',
  'prop.item_type': 'Item type:',
  'prop.import': 'Import JSON',
  'prop.import_merge': 'Merge',
  'prop.import_placeholder': 'Paste JSON to merge…',
  'prop.import_error': 'Invalid JSON',
  'prop.type.richtext': 'Rich text',
  'prop.type.text': 'Text',
  'prop.type.longtext': 'Long text',
  'prop.type.boolean': 'Boolean',
  'prop.type.int': 'Integer',
  'prop.type.uint': 'Unsigned integer',
  'prop.type.decimal': 'Decimal',
  'prop.type.date': 'Date',
  'prop.type.time': 'Time',
  'prop.type.datetime': 'Date & time',
  'prop.type.timetz': 'Time (with timezone)',
  'prop.type.datetimetz': 'Date & time (with timezone)',
  'prop.type.duration': 'Duration',
  'prop.type.array': 'Array',
  'prop.type.typed_array': 'Typed array',
  'prop.type.record': 'Record',
  'prop.type.typed_record': 'Typed record',
  'tags.title': '🏷 Manage Tags',
  'tags.new_tag': '+ New Tag',
  'tags.edit_tag': 'Edit Tag',
  'tags.new_tag_label': 'New Tag',
  'tags.name_placeholder': 'Tag name',
  'tags.color_label': 'Color',
  'tags.saving': 'Saving...',
  'tags.empty': 'No tags registered.',
  'tags.confirm_delete': 'Delete this tag? It will be removed from all images.',
  'tags.updated': 'Tag updated!',
  'tags.created': 'Tag created!',
  'tags.deleted': 'Tag deleted.',
  'users.title': '👥 Manage Users',
  'users.new_user': '+ New User',
  'users.username_label': 'Username',
  'users.admin_label': 'Administrator',
  'users.creating': 'Creating...',
  'users.create': 'Create',
  'users.edit_title': 'Edit user',
  'users.reset_pwd_title': 'Reset password',
  'users.sessions_title': 'View sessions',
  'users.delete_title': 'Delete user',
  'users.confirm_delete': 'Delete this user?',
  'users.confirm_reset_pwd': 'Generate new password for',
  'users.created': 'User created! Password:',
  'users.deleted': 'User deleted.',
  'users.updated': 'User updated!',
  'users.you_badge': 'you',
  'users.sessions_title_of': 'Sessions of',
  'users.no_sessions': 'No active sessions.',
  'users.created_at': 'Created:',
  'users.expires_at': 'Expires:',
  'users.current_session': 'current',
  'users.terminate': 'Terminate',
  'users.terminate_all': 'Terminate All',
  'users.back': 'Back',
  'users.terminated': 'Sessions terminated.',
  'users.other_terminated': 'Other sessions terminated.',
  'users.saving': 'Saving...',
  'users.changing': 'Changing...',
  'users.pwd_reset': 'New password for',
  'languages.title': '🌐 Manage Languages',
  'languages.code_placeholder': 'e.g. es',
  'languages.name_placeholder': 'e.g. Español',
  'languages.create': 'Create',
  'languages.messages_btn': 'Messages',
  'languages.system_badge': 'System',
  'languages.empty': 'No additional languages.',
  'languages.confirm_delete': 'Delete this language?',
  'languages.deleted': 'Language deleted.',
  'languages.created': 'Language created!',
  'languages.edit_title': 'Messages —',
  'languages.tab_frontend': 'Frontend',
  'languages.tab_backend': 'Backend',
  'languages.filter_placeholder': 'Filter keys...',
  'languages.reset_title': 'Reset to English default',
  'languages.save_messages': 'Save Messages',
  'languages.messages_saved': 'Messages saved!',
  'profile.title': 'My Account',
  'profile.tab_password': 'Change Password',
  'profile.tab_sessions': 'Active Sessions',
  'profile.current_password': 'Current Password',
  'profile.new_password': 'New Password',
  'profile.confirm_password': 'Confirm New Password',
  'profile.change_btn': 'Change Password',
  'profile.changing': 'Changing...',
  'profile.pwd_mismatch': 'Passwords do not match',
  'profile.pwd_too_short': 'Password must be at least 6 characters',
  'profile.pwd_changed': 'Password changed successfully!',
  'profile.no_sessions': 'No active sessions.',
  'profile.terminate_others': 'Terminate other sessions',
  'profile.terminated': 'Other sessions terminated.',
  'login.brand_sub': 'Image Annotation System',
  'login.username': 'Username',
  'login.password': 'Password',
  'login.submit': 'Login',
  'login.loading': 'Logging in...',
  'login.pow_done': '✓ Security check complete',
  'login.pow_wait': 'Verifying security',
  'login.connect_error': 'Error connecting to server',
  'login.challenge_error': 'Error obtaining new challenge',
  'editor.tool_select': 'select',
  'editor.tool_rect': 'rect',
  'editor.tool_circle': 'circle',
  'editor.tool_polygon': 'polygon',
  'editor.tool_point': 'point',
  'editor.tool_select_title': 'Select tool',
  'editor.tool_rect_title': 'Rectangle tool',
  'editor.tool_circle_title': 'Circle/Ellipse tool',
  'editor.tool_polygon_title': 'Polygon tool',
  'editor.tool_point_title': 'Point tool',
  'editor.undo_title': 'Undo (Ctrl+Z)',
  'editor.redo_title': 'Redo (Ctrl+Y)',
  'editor.zoom_out_title': 'Zoom out',
  'editor.zoom_in_title': 'Zoom in',
  'editor.fit_screen_title': 'Fit to screen',
  'editor.close_polygon': '✓ Close',
  'editor.close_polygon_title': 'Close polygon and save annotation',
  'editor.discard_polygon': '✕ Close without saving',
  'editor.discard_polygon_title': 'Discard polygon in progress',
  'editor.save': '💾 Save',
  'editor.save_title': 'Save annotations',
  'editor.saved': '✓ Saved!',
  'editor.export_json': '⬇ JSON',
  'editor.export_json_title': 'Export annotations as JSON',
  'editor.export_svg': '⬇ SVG',
  'editor.export_svg_title': 'Export as embeddable SVG',
  'editor.toggle_theme_title': 'Toggle theme',
  'editor.close': '✕ Close',
  'editor.close_title': 'Close editor',
  'editor.end_edit': '◀ End editing',
  'editor.end_edit_title': 'End annotation editing',
  'editor.editing': 'Editing',
  'editor.add_points': '+ Add points',
  'editor.add_points_title': 'Add points mode — click on edge to insert',
  'editor.remove_points': '✕ Remove points',
  'editor.remove_points_title': 'Remove points mode — double-click vertex to remove',
  'editor.adding_points': '+ adding points',
  'editor.removing_points': '✕ removing points',
  'editor.confirm_title': 'Confirm annotation',
  'editor.code_label': 'Code',
  'editor.title_label': 'Title',
  'editor.content_label': 'Content',
  'editor.link_label': 'Link',
  'editor.color_label': 'Color',
  'editor.confirm_btn': 'Confirm',
  'editor.confirm_btn_title': 'Confirm and add annotation',
  'editor.cancel_btn_title': 'Cancel annotation',
  'editor.delete_annotation': '✕ Delete',
  'editor.delete_ann_title': 'Delete this annotation',
  'editor.help_scroll': 'Scroll to zoom',
  'editor.help_middle_mouse': 'Middle button + drag to pan',
  'editor.help_ctrl_zoom': 'Ctrl+Plus / Ctrl+Minus to zoom',
  'editor.help_undo_redo': 'Ctrl+Z undo · Ctrl+Y redo',
  'editor.help_select_edit': 'Select to edit handles',
  'editor.help_polygon_add': 'Polygon: double-click on body adds point',
  'editor.help_polygon_remove': 'Polygon: double-click on vertex removes point',
  'editor.tips': 'Tips',
  'editor.annotations': 'Annotations',
  'editor.no_annotations': 'No annotations yet.',
  'editor.tags_label': 'Tags',
  'editor.annotations_saved': 'Annotations saved!',
  'editor.tags_updated': 'Tags updated!',
  'editor.selected_ann': 'Selected',
  'editor.deselect_title': 'Deselect',
  'editor.type_label': 'Type',
  'editor.coords_label': 'Coordinates (% original)',
  'editor.edit_details': '✎ Edit details',
  'editor.ctx_add_point': '+ Add point here',
  'editor.ctx_delete_point': '✕ Delete point',
  'editor.images_label': 'Images',
  'editor.store_on_server': 'Save on server',
  'editor.title_optional': 'Title (optional)',
  'editor.add_image_btn': '+ Add',
  'editor.click_edit_title': 'Click to edit title',
  'editor.no_title': 'no title',
  'editor.no_description': 'no description',
  'editor.no_link': 'no link',
  'editor.img_desc_placeholder': 'Description (optional)',
  'editor.img_link_placeholder': 'Link URL (optional)',
  'editor.img_link_text_placeholder': 'Link text (optional, default "Open page")',
  'editor.links_label': 'Links',
  'editor.link_url_placeholder': 'Link URL',
  'editor.link_label_placeholder': 'Label (default "Open page")',
  'editor.link_icon_placeholder': 'Icon (emoji or HTML)',
  'editor.link_class_placeholder': 'CSS class (optional)',
  'editor.link_icon': 'Link icon',
  'editor.icon_choose': 'Icon…',
  'editor.icon_picker_title': 'Choose an icon',
  'editor.icon_current': 'Current',
  'editor.icon_none': 'No icon',
  'editor.icon_add': '+ Add icon',
  'editor.icon_edit': 'Edit icon',
  'editor.icon_name_placeholder': 'Name',
  'editor.icon_value_placeholder': 'Emoji or HTML',
  'editor.icon_url_placeholder': 'Image URL (https://…)',
  'editor.icon_upload': 'Upload image',
  'editor.icon_delete_confirm': 'Delete this icon?',
  'editor.link_color': 'Link color',
  'editor.color_default': 'Default',
  'editor.color_primary': 'Primary',
  'editor.color_secondary': 'Secondary',
  'editor.color_success': 'Success',
  'editor.color_danger': 'Danger',
  'editor.color_warning': 'Warning',
  'editor.color_info': 'Info',
  'editor.link_hide_label': 'Icon only (label as tooltip)',
  'editor.add_link': '+ Add link',
  'editor.remove_link': 'Remove link',
  'editor.move_link_up': 'Move up',
  'editor.move_link_down': 'Move down',
  'editor.image_label': 'Image',
  'editor.tab_url': 'URL',
  'editor.tab_upload': 'Upload',
  'editor.tab_from_page': 'From page',
  'editor.store_on_disk': 'Store on disk',
  'editor.page_url_placeholder': 'Page URL (https://...)',
  'editor.add_page_url': '+ Add page',
  'editor.remove_page_url': 'Remove',
  'editor.import_from_web_btn': '+ Add',
  'editor.importing': 'Importing…',
  'editor.import_dialog_title': 'Select images to add',
  'editor.import_no_images': 'No images found.',
  'editor.import_select_all': 'Select all',
  'editor.import_clear': 'Clear',
  'editor.import_selected': 'selected',
  'editor.import_add_selected': 'Add selected',
  'editor.import_adding': 'Adding…',
  'editor.edit_ann_title': 'Edit Annotation',
  'editor.code_placeholder': 'Ex: ANN-1234',
  'editor.ann_title_placeholder': 'Annotation title',
  'editor.last_change_at': 'Last changed',
  'rich.bold': 'Bold',
  'rich.italic': 'Italic',
  'rich.underline': 'Underline',
  'rich.strike': 'Strikethrough',
  'rich.paragraph': 'Paragraph',
  'rich.heading': 'Heading',
  'rich.list': 'Bullet list',
  'rich.ordered_list': 'Numbered list',
  'rich.quote': 'Quote',
  'rich.code': 'Code',
  'rich.link': 'Link',
  'rich.clear_format': 'Clear formatting',
  'rich.undo': 'Undo',
  'rich.redo': 'Redo',
  'type.rect': 'Rectangle',
  'type.circle': 'Circle',
  'type.polygon': 'Polygon',
  'type.point': 'Point',
  'version.title': 'Version',
  'version.branch': 'Branch/Tag',
  'version.commit': 'Commit',
  'version.commit_time': 'Commit time',
  'version.executable_time': 'Executable modified',
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState('en');
  const [bundle, setBundle] = useState(EN_DEFAULTS);
  const [languages, setLanguages] = useState([{ id: '', code: 'en', name: 'English', is_system: true }]);
  const [ready, setReady] = useState(false);

  const fetchBundle = useCallback(async (code) => {
    const cached = sessionStorage.getItem(`i18n_${code}`);
    if (cached) {
      try { return JSON.parse(cached).frontend || {}; } catch {}
    }
    try {
      const res = await fetch(`/api/translations/${code}`);
      if (!res.ok) return {};
      const data = await res.json();
      sessionStorage.setItem(`i18n_${code}`, JSON.stringify(data));
      return data.frontend || {};
    } catch { return {}; }
  }, []);

  useEffect(() => {
    const init = async () => {
      try {
        const res = await fetch('/api/languages');
        if (res.ok) {
          const langs = await res.json();
          setLanguages(langs);
          const codes = langs.map(l => l.code);
          const stored = localStorage.getItem('annotate_lang');
          const browser = navigator.language?.toLowerCase() || '';
          const browserPrefix = browser.slice(0, 2);
          // exact (case-insensitive) match, then primary-subtag match so a
          // browser "pt" / "pt-br" resolves to the "pt-BR" language.
          const byTag = codes.find(c => c.toLowerCase() === browser);
          const byPrefix = codes.find(c => c.toLowerCase().slice(0, 2) === browserPrefix);
          const detected = (stored && codes.includes(stored)) ? stored
            : byTag || (browserPrefix && byPrefix) || 'en';
          if (detected !== 'en') {
            const b = await fetchBundle(detected);
            setBundle({ ...EN_DEFAULTS, ...b });
            setLangState(detected);
          }
        }
      } catch {}
      setReady(true);
    };
    init();
  }, [fetchBundle]);

  const setLang = useCallback(async (code) => {
    localStorage.setItem('annotate_lang', code);
    setLangState(code);
    sessionStorage.removeItem(`i18n_${code}`); // force re-fetch
    if (code === 'en') {
      setBundle(EN_DEFAULTS);
    } else {
      const b = await fetchBundle(code);
      setBundle({ ...EN_DEFAULTS, ...b });
    }
  }, [fetchBundle]);

  const t = useCallback((key) => bundle[key] ?? EN_DEFAULTS[key] ?? key, [bundle]);

  return (
    <I18nContext.Provider value={{ t, lang, setLang, languages, setLanguages, ready }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
